import { gql } from '@apollo/client';

export const ROTATIONSPLAN_BY_ID = gql(`
  query mitarbeiter_rotationsplanById($rotationsplanId: String!) {
   mitarbeiter_rotationsplanById(rotationsplanId: $rotationsplanId){
      id
      standortId
      mitarbeiter {
        id
        bildUrl
        vorname
        nachname
        arbeitsbereich {
          id
          markierung
          name
          standort {
            id
            name
            storenummer
          }
        }
        standort {
          id
          name
          storenummer
        }
      }
      beruf {
        id
        abkuerzung
        name
        markierung
        istAusbildung
      }
      abwesenheiten {
        von
        bis
        grund
        id
        faktor
      }
      abschnitte {
        id
        name
        position
        stationen {
            __typename
            ... on mitarbeiter_rotationsplanArbeitsbereichStation {
                id
                von
                bis
                lernziele
                arbeitsbereich {
                    name
                    id
                    markierung
                    standort {
                      id
                      name
                      storenummer
                    }
                }
                abteilungsleiter {
                    id
                    vorname
                    nachname
                }
                frist {
                  id
                  erinnerungen {
                    id
                    erinnernAm
                    managerId
                  }
                }
            }
            ... on mitarbeiter_rotationsplanAbwesenheitsStation {
              id
              von
              bis
              name
            }
        }
      }
    }
}
`);
